import avatar from '../assets/images/avatares/amanda-baroni-perfil.jpg';
import audio from '../assets/sounds/amanda-baroni.mp3';

import amanda01 from '../assets/images/amanda-baroni/AmandaBaroni_01.jpg';
import amanda02 from '../assets/images/amanda-baroni/AmandaBaroni_02.jpg';
import amanda03 from '../assets/images/amanda-baroni/AmandaBaroni_03.jpg';
import amanda04 from '../assets/images/amanda-baroni/AmandaBaroni_04.jpg';
import amanda05 from '../assets/images/amanda-baroni/Amanda_Baroni_Elementos_da_Minha_Natureza_1.jpg';
import amanda06 from '../assets/images/amanda-baroni/Amanda_Baroni_Elementos_da_Minha_Natureza_2.jpg';
import amanda07 from '../assets/images/amanda-baroni/Amanda_Baroni_Elementos_da_Minha_Natureza_3.jpg';
import amanda08 from '../assets/images/amanda-baroni/Amanda_Baroni_Elementos_da_Minha_Natureza_4.jpg';
import amanda09 from '../assets/images/amanda-baroni/Amanda_Baroni_Elementos_da_Minha_Natureza_5.jpg';
import amanda10 from '../assets/images/amanda-baroni/bboy.jpg';
import amanda11 from '../assets/images/amanda-baroni/Amanda_Baroni_Elementos_da_Minha_Natureza_11.jpg';
import amanda12 from '../assets/images/amanda-baroni/Amanda_Baroni___Elementos_da_Minha_Natureza__12.jpg';



const amandaData = {
    avatar,
    amanda01,
    amanda02,
    amanda03,
    amanda04,
    amanda05,
    amanda06,
    amanda07,
    amanda08,
    amanda09,
    amanda10,
    amanda11,
    amanda12,
    audio
}

export default amandaData
